<template>
  <v-flex xs12 row>
  	<v-layout row wrap>
  		<v-flex xs12>
  			
  		</v-flex>
  	</v-layout>

	<v-layout py-3>
   		<v-flex xs12>
   			<v-card>
	   			<v-card-title>

            <v-text-field v-model="filter.code" label="Order ID" class="mr-3"></v-text-field>
            
            <autocomplete label="Search LTP Code" sub-title="title" v-model="filter.agent" search-key="id" async api-path="agent" clearable />
            
            <autocomplete label="Search Executive" sub-title="mobile" v-model="filter.executive" search-key="first_name" async api-path="admin-search" clearable :custom-params="executiveSearchParams" />

            <search-btn @click="filterData" />

            <v-spacer></v-spacer>

			    </v-card-title>
	   			<v-data-table
				    :headers="headers"
				    :loading="processing"
				    :items="items"
				    item-key="id"
				    hide-actions
            disable-initial-sort
				  >
				  	<v-progress-linear slot="progress" color="blue" indeterminate></v-progress-linear>
				    <template slot="headerCell" slot-scope="props">
				      <v-tooltip bottom>
				        <span slot="activator">
				          {{ props.header.text }}
				        </span>
				        <span>
				          {{ props.header.text }}
				        </span>
				      </v-tooltip>
				    </template>
				    <template slot="items" slot-scope="props">
              <tr is="commission-list-item" :item="props.item" @edit="setEditingItem" @confirm="confirmCommissionItem"></tr>
				    </template>
				    <template slot="no-data" v-if="!processing && !items.length">
				      <v-alert :value="true" color="error" icon="warning">
				        Sorry, nothing to display here :(
				      </v-alert>
				    </template>
				  </v-data-table>

          <v-pagination @loadPage="loadPage" />

			</v-card>
   		</v-flex>

   	</v-layout>
      
    <action-dialog action="approve" :status="approvingDialog" @close="closeConfirmDialog" @success="confirmCommission" />

    <v-dialog v-model="editDialog" max-width="450px">
      <v-card>
        <v-card-title>
          <span class="title text-uppercase">Update Commission</span>
        </v-card-title>
        <!-- <v-divider></v-divider> -->
        <v-card-text>
          <v-container grid-list-md py-0>
            <v-layout wrap>
              <v-flex xs12 sm7>
                <v-text-field v-model="editingItem.code" label="Order ID" readonly></v-text-field>
              </v-flex>
              <v-flex xs12 sm5 pl-4 class="text-xs-right">
                <label class="caption font-weight-light grey--text">Order Total</label>
                <div class="subheading">{{editingItem.total | roundValue}}</div>
              </v-flex>
              <v-flex xs12 sm7 v-if="editingItem.agent">
                <v-text-field v-model="editingItem.agent_commission_percent" type="number" label="Agent Commission (%)"></v-text-field>
              </v-flex>
              <v-flex xs12 sm5 pl-4 v-if="editingItem.agent" class="text-xs-right">
                <label class="caption font-weight-light grey--text">Amount</label>
                <div class="subheading">{{editingItem.agent_commission_amount | roundValue}}</div>
              </v-flex>
              <v-flex xs12 sm7>
                <v-text-field v-model="editingItem.retailer_commission_percent" type="number" label="Branch Commission (%)"></v-text-field>
              </v-flex>
              <v-flex xs12 sm5 pl-4 class="text-xs-right">
                <label class="caption font-weight-light grey--text">Amount</label>
                <div class="subheading">{{editingItem.retailer_commission_amount | roundValue}}</div>
              </v-flex>
              <v-flex xs12 sm7 v-if="editingItem.executive">
                <v-text-field v-model="editingItem.executive_commission_percent" type="number" label="Executive Commission (%)"></v-text-field>
              </v-flex>
              <v-flex xs12 sm5 pl-4 v-if="editingItem.executive" class="text-xs-right">
                <label class="caption font-weight-light grey--text">Amount</label>
                <div class="subheading">{{editingItem.executive_commission_amount | roundValue}}</div>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card-text>
        <!-- <v-divider></v-divider> -->
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="blue darken-1" flat @click="closeEditingDialog">Close</v-btn>
          <v-btn color="blue darken-1" flat @click="addCommission">Update</v-btn>
        </v-card-actions>
      </v-card>
  </v-dialog>
    
  </v-flex>
</template>

<script>

  import CommissionListItem from './CommissionListItem'

  import userRoles from '../config/roles'

  export default {
    name: 'CommissionList',
    data () {
      return {
      	title: "Commission List",
      	processing: false,
      	items: [],
        headers: [
          { text: 'Order ID', value: 'code'},
          { text: 'Total (Rs.)', value: 'total', align: 'right'},
          { text: 'Customer', value: 'customer_name'},
          { text: 'Agent & Commission (Rs.)', value: 'agent_name'},
          { text: 'Branch & Commission (Rs.)', value: 'retailer_name'},
          { text: 'Executive & Commission (Rs.)', value: 'executive_name'},
          { text: 'Actions', value: 'id', sortable: false }
        ],
        filter: {
          code: "",
          agent: "",
          executive: ""
        },
        agentLoading: false,
        agentSearchText: "",
        agents: [],
        executives: [],
        executiveLoading: false,
        executiveSearchText: "",
        editingItem: {},
        editDialog: false,
        approvingItem: null,
        approvingDialog: false,
        executiveSearchParams:{
          privilage: userRoles.executive
        }
      }
    },
    created () {
      	let breadcrumbs = [
	      	{
	          text: 'Dashboard',
	          disabled: false,
	          href: '/dashboard'
	        },
	        {
	          text: 'Commission',
	          disabled: true
	        },
	        {
	          text: 'List',
	          disabled: true
	        }
       ]

      this.$store.commit('setBreadcrumbs', breadcrumbs)
      this.$store.commit('setPageTitle', 'Manage Commission')
    },
    methods: {

      loadPage () {

        let api_path = this.config.apis.getInvoiceCommissions.replace(":page", this.currentPage).replace(":perPage", this.paginationOptions.rowsPerPage)
          
        let filterArray = []

        for (const [key, val] of Object.entries(this.filter)) {
          filterArray.push(`${key}=${val}`)
        }

        api_path += '?' + filterArray.join('&')
        
        this.processing = true
        this.axios.get(api_path)
          .then((response) => {
            this.processing = false
            if (this.isSuccessResponse(response)) {
            	this.items = response.data.data.items
              this.$store.commit('setItemsCount', response.data.data.total)
            }
            else{
            	this.items = []
              this.$store.commit('setItemsCount', 0)
            }
          })
          .catch((error) => {
            this.processing = false
          })
      },

      searchAgents () {
        this.agentLoading = true
        this.axios.get(`${this.config.apis.searchAgents}?id=${this.agentSearchText}`)
        .then((response) => {
            this.agentLoading = false
            if (this.isSuccessResponse(response)) {
              this.agents = response.data.data
            }
        })
        .catch((error) => {
            this.agentLoading = false
        })
      },

      searchExecutives () {
        let api_path = this.config.apis.searchExecutives
        if (this.executiveSearchText) {
          api_path += `?first_name=${this.executiveSearchText}`
        }

        this.executiveLoading = true
        this.axios.get(api_path)
        .then((response) => {
            this.executiveLoading = false
            if (this.isSuccessResponse(response)) {
              this.executives = response.data.data
            }
        })
        .catch((error) => {
            this.executiveLoading = false
        })
      },

      setEditingItem (item) {
        
        this.editingItem = { 
          id: item.id,
          code: item.code,
          total: item.total, 
          agent: item.agent,
          agent_commission_id: item.agent_commission_id,
          agent_commission_percent: item.agent_commission_percent || 0,
          agent_commission_amount: item.agent_commission_amount || 0,
          executive: item.executive,
          executive_commission_id: item.executive_commission_id,
          executive_commission_percent: item.executive_commission_percent || 0,
          executive_commission_amount: item.executive_commission_amount || 0,
          retailer: item.retailer,
          retailer_commission_id: item.retailer_commission_id,
          retailer_commission_percent: item.retailer_commission_percent || 0,
          retailer_commission_amount: item.retailer_commission_amount || 0
        }

        this.editDialog = true
      },

      closeEditingDialog () {
        this.editingItem = {}
        this.editDialog = false
      },

      addCommission () {
        
        if (!this.editingItem) return

        if (this.editingItem.executive && this.editingItem.executive_commission_percent < 0){
          this.notifyError('updateError')
          return
        }

        if (this.editingItem.agent && this.editingItem.agent_commission_percent < 0){
          this.notifyError('updateError')
          return
        }

        if (this.editingItem.executive && this.editingItem.retailer_commission_percent < 0){
          this.notifyError('updateError')
          return
        }

        this.processing = true
        this.axios.put(this.config.apis.updateCommission.replace(":id", this.editingItem.id), this.editingItem)
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              let item = this.items.filter(item => item.id === this.editingItem.id)

              if (item.length) {
                item = item[0]
                item.commission_status = this.config.commissionStatus.added
                item.agent_commission_percent = this.editingItem.agent_commission_percent
                item.agent_commission_amount = this.editingItem.agent_commission_amount
                item.retailer_commission_percent = this.editingItem.retailer_commission_percent
                item.retailer_commission_amount = this.editingItem.retailer_commission_amount
                item.executive_commission_percent = this.editingItem.executive_commission_percent
                item.executive_commission_amount = this.editingItem.executive_commission_amount
              }

              this.notifySuccess('updateSuccess')
              this.closeEditingDialog()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      confirmCommissionItem (item) {
        this.approvingItem = item
        this.approvingDialog = true
      },

      closeConfirmDialog () {
        this.approvingItem = null
        this.approvingDialog = false
      },

      confirmCommission () {
        this.processing = true
        this.axios.put(this.config.apis.approveCommission.replace(":id", this.approvingItem.id))
          .then((response) => {
            if (this.isSuccessResponse(response)) {

              this.approvingItem.commission_status = this.config.commissionStatus.approved

              this.notifySuccess('updateSuccess')
              this.closeConfirmDialog()
            }
            else{
              this.notifyError('updateError')
            }
            this.processing = false
          })
          .catch((error) => {
            this.processing = false
          })
      },

      calculateAgentCommission () {

      }

    },
    mounted () {
      
    },

    computed: {

      agent_commission () {

        let commission = 0
        let percent = this.editingItem.agent_commission_percent || 0

        if (percent > 0) {
          commission = ( this.editingItem.total * percent ) / 100
        }
        
        return commission
      },

      retailer_commission () {

        let commission = 0
        let agent_commission = this.editingItem.agent_commission_amount || 0
        let percent = this.editingItem.retailer_commission_percent || 0
        let total = this.editingItem.total - agent_commission

        if (percent > 0) {
          commission = ( total * percent ) / 100
        }
        
        return commission
      },

      executive_commission () {

        let commission = 0
        let agent_commission = this.editingItem.agent_commission_amount || 0
        let retailer_commission = this.editingItem.retailer_commission_amount || 0
        let percent = this.editingItem.executive_commission_percent || 0
        let total = this.editingItem.total - ( agent_commission + retailer_commission )

        if (percent > 0) {
          commission = ( total * percent ) / 100
        }
        
        return commission
      }

    },

    watch: {

      agentSearchText (val, oldVal) {
        if (val && val != oldVal) {
          this.searchAgents()
        }
      },

      executiveSearchText (val, oldVal) {
        if (val && val != oldVal) {
          this.searchExecutives()
        }
      },

      agent_commission (val) {
        this.editingItem.agent_commission_amount = val
      },

      retailer_commission (val) {
        this.editingItem.retailer_commission_amount = val
      },

      executive_commission (val) {
        this.editingItem.executive_commission_amount = val
      }

    },
    
    components: {
      'commission-list-item': CommissionListItem
    }

  }
</script>
